var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2425_5922",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2425_5922)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.2915 18.3337C9.08317 18.3337 8.87484 18.292 8.6665 18.2087C8.45817 18.1253 8.27067 18.0003 8.104 17.8337L2.14567 11.8753C1.979 11.7087 1.85748 11.5246 1.78109 11.3232C1.7047 11.1219 1.6665 10.917 1.6665 10.7087C1.6665 10.5003 1.7047 10.292 1.78109 10.0837C1.85748 9.87533 1.979 9.68783 2.14567 9.52116L9.479 2.16699C9.63178 2.01421 9.81234 1.89269 10.0207 1.80241C10.229 1.71213 10.4443 1.66699 10.6665 1.66699H16.6457C17.104 1.66699 17.4964 1.83019 17.8228 2.15658C18.1491 2.48296 18.3123 2.87533 18.3123 3.33366V9.31283C18.3123 9.53505 18.2707 9.74685 18.1873 9.94824C18.104 10.1496 17.9859 10.3267 17.8332 10.4795L10.479 17.8337C10.3123 18.0003 10.1248 18.1253 9.9165 18.2087C9.70817 18.292 9.49984 18.3337 9.2915 18.3337ZM9.2915 16.667L16.6457 9.29199V3.33366H10.6873L3.33317 10.7087L9.2915 16.667ZM14.5623 6.66699C14.9096 6.66699 15.2047 6.54546 15.4478 6.30241C15.6908 6.05935 15.8123 5.76421 15.8123 5.41699C15.8123 5.06977 15.6908 4.77463 15.4478 4.53158C15.2047 4.28852 14.9096 4.16699 14.5623 4.16699C14.2151 4.16699 13.92 4.28852 13.6769 4.53158C13.4339 4.77463 13.3123 5.06977 13.3123 5.41699C13.3123 5.76421 13.4339 6.05935 13.6769 6.30241C13.92 6.54546 14.2151 6.66699 14.5623 6.66699Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.905f2e13ec23d845f31bcad85f85851a.svg";
export { ForwardRef as ReactComponent };